/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AssociatedcompanyPolosDropdown200,
  GetApiV1AssociatedcompanyPolosDropdown401,
  GetApiV1AssociatedcompanyPolosDropdown500,
  GetApiV1AssociatedcompanyPolosDropdownQueryParams,
  GetApiV1AssociatedcompanyPolosDropdownQueryResponse,
} from "../../types/associatedCompanySharedController/GetApiV1AssociatedcompanyPolosDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1AssociatedcompanyPolosDropdownQueryParamsSchema = z
  .object({
    filter: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1AssociatedcompanyPolosDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AssociatedcompanyPolosDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1AssociatedcompanyPolosDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AssociatedcompanyPolosDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyPolosDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AssociatedcompanyPolosDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyPolosDropdown500>;

export const getApiV1AssociatedcompanyPolosDropdownQueryResponseSchema = z.lazy(
  () => getApiV1AssociatedcompanyPolosDropdown200Schema,
) as unknown as ToZod<GetApiV1AssociatedcompanyPolosDropdownQueryResponse>;
